import { PROMO_DISCOUNT_ADD } from '@/utils/permissions'

const state = {
  loading: false,
  total: 0,
  FilteredCount: 0,
  promoDiscounts: [],

  promoDiscountTable: {
    addNewButton: {
      permission: [PROMO_DISCOUNT_ADD],
      btnIcon: 'PlusIcon',
      btnTitle: 'Add New Promo Discount',
      btnEvents: {
        click() {
          this.addDiscountModal.isModalMounted = true
        }
      }
    },
    tableColumns: [
      {
        title: 'Sr #',
        columnSortKey: ''
      },
      {
        title: 'Discount Name',
        columnSortKey: ''
      },
      {
        title: 'Discount'
      },
      {
        title: 'Active'
      },
      {
        title: 'Actions'
      }
    ],
    addDiscountModal: {
      isModalMounted: false,
      isModalShow: false
    }
  }
}

export default state
